module.exports = __webpack_public_path__ + "img/126.10.f8d95a12.png";